import React, { useEffect, useState } from "react";
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import Header from "../layout/header";
import AttendanceRecord from '../RegularizationModule/AttendanceRecord';
import './monthlyregularization.css';

const MonthlyRegularization = ({
    history,
    getDaysData,
    getAllTheDaysData = [],
    getMonthsNameFilter,
    getMonthsFilter = []
}) => {

  const [isLoading, setIsLoading] = useState(false)
  const currentMonth = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();


  const now = new Date();
  const options = { year: 'numeric', month: 'long' };
  const formattedDate = now.toLocaleDateString('en-US', options);

  useEffect(() => {
    (async () => {
        setIsLoading(true)
        await getDaysData(currentMonth, currentYear)
        await getMonthsNameFilter()
        setIsLoading(false)
    })()
}, [getDaysData])



  return (
    <>
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header 
              title={'Attendance Record'} 
              // title={`${getAllTheDaysData?.data[0]?.Month} ${getAllTheDaysData?.data[0]?.currentYear} - Attendance`}
              history={history} 
            />
            <div className="container-fluid common-bg">
              {/*Heading*/}
              <div className="container-fluid bootstrap snippets bg-white">
                      <AttendanceRecord 
                      records={getAllTheDaysData?.data} 
                      getMonthsFilter={getMonthsFilter}
                      getDaysData={getDaysData}
                      />
              </div>
            </div>
          </div>
        </div>
        
      </div>
      {/* section ends */}
    </>
  );
};

export default MonthlyRegularization;

